module.exports = __webpack_public_path__ + "static/media/edit-pop-up-delete-button.d34b412a.svg";